import { render, staticRenderFns } from "./parts-sales-list.vue?vue&type=template&id=260e52d7&scoped=true&"
import script from "./parts-sales-list.vue?vue&type=script&lang=ts&"
export * from "./parts-sales-list.vue?vue&type=script&lang=ts&"
import style0 from "./parts-sales-list.vue?vue&type=style&index=0&id=260e52d7&prod&lang=scss&scoped=true&"
import style1 from "./parts-sales-list.vue?vue&type=style&index=1&id=260e52d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260e52d7",
  null
  
)

export default component.exports